import { useMemo, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { ChartData, ChartOptions } from 'chart.js';
import { ChartComponentProps, LineChartHookReturn } from './types';
import { handleSegmentClick, handleLabelClick } from './utils';
import { generateStackedChartData } from './dataUtils';
import { createChartOptions } from './chartConfig';
import { AggregatedOrderViewType } from 'src/gql/graphql';

export const useLineChart = ({
  table,
  grouping,
  rowSelection,
  setRowSelection,
  borderColor,
  textColor,
}: ChartComponentProps): LineChartHookReturn => {
  const chartRef = useRef<any>(null);

  const chartData = useMemo(() => {
    return generateStackedChartData(
      table,
      grouping,
      rowSelection,
      AggregatedOrderViewType.LineChart
    ) as ChartData<'line'>;
  }, [
    table.options.data,
    table.getState().columnFilters,
    table.getState().grouping,
    grouping,
    rowSelection,
  ]);

  const chartOptions = useMemo((): ChartOptions<'line'> => {
    return createChartOptions(
      AggregatedOrderViewType.LineChart,
      borderColor,
      textColor,
      table,
      rowSelection,
      setRowSelection,
      handleSegmentClick,
      handleLabelClick
    ) as ChartOptions<'line'>;
  }, [
    borderColor,
    textColor,
    table.options.data,
    table.getState().columnFilters,
    table.getState().grouping,
    rowSelection,
    setRowSelection,
  ]);

  return {
    chartData,
    chartOptions,
    chartRef,
  };
};

export default function LineChart(props: ChartComponentProps) {
  const { chartData, chartOptions, chartRef } = useLineChart(props);

  return <Line data={chartData} options={chartOptions} ref={chartRef as any} />;
}
